import React, { useEffect } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import fayvenDashImage from '../../../assets/img/fayvenDashImage.png';
import { Image, Layout, Loading, UserNavbar } from '../../../components';
import { getRatingsByVenueOwner } from '../../../core/ratings/actions';
import RatingCard from './components/RatingCard';

function Reviews() {
  const dispatch = useDispatch();
  const { ratings, loading } = useSelector((store) => store.ratings);
  const { user } = useSelector((store) => store.users);

  useEffect(() => {
    if (!user?.id) return;

    dispatch(getRatingsByVenueOwner(user.id));
  }, [dispatch, user]);

  return (
    <Layout>
      {loading && <Loading />}
      <UserNavbar />
      <Image src={fayvenDashImage} alt="" className="dashboard__banner" />
      <Grid container justifyContent="center">
        <Grid item xs={12} textAlign="center">
          <Typography variant="h3" color="#EE7B57" fontWeight="bold" marginTop={4}>
            Reviews
          </Typography>
        </Grid>
        <Grid item xs={8}>
          {ratings?.length > 0 &&
            ratings.map((rating) => (
              <Box key={rating.id} mb={1}>
                <RatingCard rating={rating} />
              </Box>
            ))}
        </Grid>
      </Grid>
    </Layout>
  );
}

export default Reviews;
